import { createContext } from 'react';

export interface ThemeContextType {
  theme: string;
  setTheme: (name: string) => void;
}

export const ThemeContext = createContext<ThemeContextType>({
  theme: 'NebulaFighterTheme',
  setTheme: () => {}
});
